import { type IItems } from "./IItems";
import { type IListStore } from "./ListStore";

export class StoreItems<S> implements IItems<S> {
	private readonly store: IListStore<S>;

	constructor(store: IListStore<S>) {
		this.store = store;
	}

	data(key: number): S {
		return (this.store.items as any)[key];
	}

	load(keys: number[]): Promise<void> {
		return this.store.load(keys);
	}

	get isResetting(): number {
		return this.store.isResetting;
	}

	invalidate(key: S): Promise<void> {
		return this.store.invalidate(key);
	}

	get items() {
		return this.store.items;
	}

	get totalCountEstimate() {
		return this.store.totalCountEstimate;
	}

	reset(): Promise<void> {
		return this.store.reset();
	}
}
